/**
 * @file store文件
 */
import Vue from 'vue';
import Vuex from 'vuex';
import {getParamsFromUrl} from '@baidu/map-fe-utils';
import {getObjectValuesByKey} from '@/pages/dache-activity/helper/util';
import server from '../service';
import Const from '@/pages/dache-activity/constant/Constant';
import md5js from 'crypto-js/md5.js';
Vue.use(Vuex);

const state = {
    // 基础信息
    // isNative: true, // 判断端内外
    isNative: Const.devTap.isNative, // 判断端内外
    activityType: Const.activityType.default,
    localParams: {},
    safeBarHeight: 0, // 安全高度
    // 基础数据
    baseData: {},
    // 基础样式数据
    baseStyle: {},
    redShare: null,
    preLoadImgs: [],
    // 功能模块
    modules: [],
    // 底部数据
    bottomData: {},
    // 底部分享数据
    bottomShareData: {},
    // 底部数据
    floatBtn: {},
    // 分享配置
    shareConf: {},
    // 是否登录
    isLogin: false,
    // 是否点击登录
    needLogin: false,
    // 是否点击登录
    clickLogin: false,
    //  0-活动未开始 1-已开始 2-紧急下线 9-活动已结束
    activityStatus: Const.activityStatus.hasStarted,
    // 活动规则
    rules: [],
    // 是否需要挽留弹窗
    needRemind: false,
    // 活动状态弹窗样式
    remindStyle: {},
    // 是否需要活动状态弹窗
    needActivityStatusDialog: false,
    // 活动状态弹窗样式
    dialogStatusesStyle: {},
    // 活动状态
    dialogStatuses: [],
    // 活动id
    eventKey: Const.eventKeys.default,
    token: ''
};

const mutations = {
    // 获取local页面数据
    setLocalParams(state, data) {
        state.localParams = data || {};
        if (data.activity) {
            state.activityType = data.activity;
        }
        else {
            state.activityType = Const.activityType.default;
        }
    },
    // 设置安全高度
    setSafeHeight(state, data) {
        state.safeBarHeight = data;
    },
    // 登录信息设置
    setIsLogin(state, data) {
        state.isLogin = data;
    },
    // 主页数据
    setMainData(state, data) {
        Vue.set(state, 'baseData', data.base);
        Vue.set(state, 'baseStyle', data.style);
        Vue.set(state, 'redShare', data.red_share);
        Vue.set(state, 'modules', data.modules);
        Vue.set(state, 'bottomData', data.bottom);
        Vue.set(state, 'bottomShareData', data.bottom_share);
        Vue.set(state, 'floatBtn', data.floatBtn);
        Vue.set(state, 'shareConf', state.baseData.share);
        let preloadImgs = [];
        const imgLabel = Const.styleLabel.image[0];
        preloadImgs = preloadImgs.concat(getObjectValuesByKey(state.baseStyle, imgLabel))
            .concat(getObjectValuesByKey(state.bottomData, imgLabel))
            .concat(getObjectValuesByKey(state.bottomShareData, imgLabel))
            .concat(getObjectValuesByKey(state.floatBtn, imgLabel));
        state.modules.forEach(item => {
            preloadImgs = preloadImgs.concat(getObjectValuesByKey(item, imgLabel));
            item.list.forEach(i => {
                if (i?.button?.win_img) {
                    preloadImgs = preloadImgs.concat(getObjectValuesByKey(i.button.win_img, imgLabel));
                }
            });
        });
        state.preLoadImgs = preloadImgs;
        state.isLogin = !!Number(state.baseData.is_login);
        state.needLogin = Number(state.baseData.click_login) !== Const.loginType.notNeed;
        state.clickLogin = Number(state.baseData.click_login) === Const.loginType.click;
        state.activityStatus = state.baseData.active_status;
        state.needRemind = !!Number(state.baseData.remind);
        if (state.needRemind && state.baseStyle.remind) {
            state.remindStyle = state.baseStyle.remind;
        }
        state.needActivityStatusDialog = !!Number(state.baseData.active_status_dialog);
        if (state.needActivityStatusDialog && state.baseStyle.activityStatusDialog) {
            state.dialogStatusesStyle = state.baseStyle.activityStatusDialog;
            state.dialogStatuses = Object.keys(state.dialogStatusesStyle).map(v => Number(v));
        }
        state.token = state.baseData.token || 'token';
        state.rules = state.baseData.rules || [];
    },
    updateCard(state, data) {
        if (data.moduleIndex > -1 && data.cardIndex > -1) {
            state.modules[data.moduleIndex].list[data.cardIndex].count_down_time = data.card.count_down_time;
            state.modules[data.moduleIndex].list[data.cardIndex].card_id = data.card.card_id;
            state.modules[data.moduleIndex].list[data.cardIndex].style = data.card.style;
            state.modules[data.moduleIndex].list[data.cardIndex].button = data.card.button;
        }
    },
    updateCardButton(state, data) {
        if (data.moduleIndex > -1 && data.cardIndex > -1) {
            state.modules[data.moduleIndex].list[data.cardIndex].button = data;
        }
    },
    updateCardStatus(state, data) {
        if (data.moduleIndex > -1 && data.cardIndex > -1) {
            state.modules[data.moduleIndex].list[data.cardIndex].button.status = data.status;
        }
    }
};
const getters = {
};
const actions = {
    setLocalParams: ({commit}) => {
        const params = getParamsFromUrl();
        commit('setLocalParams', params);
    },
    // 主页部分
    getMainData: ({state, commit}, param) => {
        // 主接口透传所有参数给服务端
        const urlParams = {
            ...state.localParams,
            ...param,
            qt: state.activityType
        };
        return server('MainData', urlParams).then(res => {
            if (res && res.err_no === 0 && res.data) {
                commit('setMainData', res.data);
                return res;
            }
            throw new Error(res.err_msg);
        });
    },
    // 获取卡片
    getCardDetail: ({state, commit}, param = {}) => {
        // 对于券包的更新索引
        const urlParams = {
            ...param,
            token: state.token
        };
        const paramStr = window.yymap.util.stringifyObject(urlParams);
        // 对参数进行加密得到签名
        urlParams.sign_key = md5js(paramStr).toString();
        delete urlParams.token;
        if (state.localParams && state.localParams.cuid) {
            urlParams.cuid = state.localParams.cuid;
        }
        // sign_key加密
        return server('GetCardDetail', urlParams);
    },
    // 获取优惠券
    getCard: ({state, commit}, param = {}) => {
        // 对于券包的更新索引
        const {moduleIndex = 0, cardIndex = 0} = param;
        if (param) {
            delete param.moduleIndex;
            delete param.cardIndex;
        }
        const urlParams = {
            ...param,
            token: state.token
        };
        const paramStr = window.yymap.util.stringifyObject(urlParams);
        // 对参数进行加密得到签名
        urlParams.sign_key = md5js(paramStr).toString();
        delete urlParams.token;
        if (state.localParams && state.localParams.cuid) {
            urlParams.cuid = state.localParams.cuid;
        }
        // sign_key加密
        return server('GetCard', urlParams).then(res => {
            if (res && res.err_no === 0 && res.data) {
                commit('updateCardButton', {
                    ...res.data,
                    moduleIndex: moduleIndex,
                    cardIndex: cardIndex
                });
            }
            return res;
        });
    },
    getTask: ({state, commit}, param = {}) => {
        const urlParams = {
            ...param,
            token: state.token
        };
        const paramStr = window.yymap.util.stringifyObject(urlParams);
        // 对参数进行加密得到签名
        urlParams.sign_key = md5js(paramStr).toString();
        delete urlParams.token;
        if (state.localParams && state.localParams.cuid) {
            urlParams.cuid = state.localParams.cuid;
        }
        // sign_key加密
        return server('GetTask', urlParams);
    },
    getCou: ({state, commit}, params = {}) => {
        const urlParams = {
            params,
            token: state.token
        };
        const paramStr = window.yymap.util.stringifyObject(urlParams);
        // 对参数进行加密得到签名
        // let sign_key1 = md5('params=' + encodeURIComponent(params) + '&token=' + state.token);
        urlParams.sign_key = md5js(paramStr).toString();
        delete urlParams.token;
        if (state.localParams && state.localParams.cuid) {
            urlParams.cuid = state.localParams.cuid;
        }
        // sign_key加密
        return server('GetCou', urlParams);
    }
};
/* eslint-disable */
export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations
});
